(function (Drupal, $, settings) {
    Drupal.behaviors.waitListBlock = {
      attach: function attach(context) {

        let $searchContainer = $(context).find(".location-search-input-container");

        if ($searchContainer.length) {
          let $input = $searchContainer.find("input[type='search']");

          //for every accordion on this page
          $(context).find(".location-search-input-container button.clear").click(function (e) {
            e.preventDefault();
            $input.val('');
            $input.trigger('change');
          });

          $input.on('keyup change', function(e) {
            $searchContainer.find("button.clear").toggleClass("show", !!$input.val());
          });

        }
      }
    }
  }
)(Drupal, jQuery);
